import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { formatDate } from '../utils/dateFormatter';

interface FulfillmentData {
  date: string;
  fulfilledCount: number;
  incomingCount: number;
  pendingCount: number;
}

interface FulfillmentChartProps {
  data: FulfillmentData[];
  height?: number;
}

export default function FulfillmentChart({ data, height = 300 }: FulfillmentChartProps) {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={data} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="var(--border-color)" vertical={false} />
        <XAxis 
          dataKey="date" 
          tickFormatter={(value) => {
            const date = new Date(value);
            return `${date.getDate()}/${date.getMonth() + 1}`;
          }}
          stroke="var(--text-secondary)"
          fontSize={12}
        />
        <YAxis stroke="var(--text-secondary)" allowDecimals={false} fontSize={12} />
        <Tooltip 
          contentStyle={{ backgroundColor: 'var(--bg-secondary)', border: '1px solid var(--border-color)', borderRadius: '8px', fontSize: '12px' }}
          labelFormatter={(value) => formatDate(value)}
          formatter={(value: number, name: string) => {
            if (name === 'pendingCount') return [value, 'Pendientes (Acumulado)'];
            if (name === 'incomingCount') return [value, 'Entrantes (Diario)'];
            if (name === 'fulfilledCount') return [value, 'Preparados (Diario)'];
            return [value, name];
          }}
        />
        <Legend wrapperStyle={{ paddingTop: '5px', fontSize: '12px' }} />
        <Bar dataKey="incomingCount" name="Entrantes (Diario)" fill="#4caf50" radius={[4, 4, 0, 0]} />
        <Bar dataKey="fulfilledCount" name="Preparados (Diario)" fill="#2196f3" radius={[4, 4, 0, 0]} />
        <Bar dataKey="pendingCount" name="Pendientes (Acumulado)" fill="#9c27b0" radius={[4, 4, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
}



